import React from 'react'

import '../terminal.css';
import '../fonts/Terminal.woff';
import Box from '../Components/box.jsx';
import download from '../Assets/download.svg'
import { useEffect } from 'react';
import YoutubeEmbed from '../Components/youtube.jsx';
import Car from '../Components/carousel.jsx';

import rbtideasUpdated from '../Assets/welldone/rbtideasUpdated.jpg'
import guild from '../Assets/welldone/the_correct_guild.png'
import twis from '../Assets/welldone/twis_for_rt_conceptart.png'
import uuolin from '../Assets/welldone/uuolin.png'
import twat from '../Assets/welldone/twat.png'
import torus2b from '../Assets/welldone/torus2b.PNG'
import digrade from '../Assets/welldone/digrade.PNG'
import dunka from '../Assets/welldone/dunka.png'
import holup from '../Assets/welldone/holup.png'
import hyperjuice from '../Assets/welldone/hyperjuice.png'
import rased from '../Assets/welldone/rased.png'
import rentilled from '../Assets/welldone/rentilled.png'
import tamer from '../Assets/welldone/tamer.png'
import tase from '../Assets/welldone/tase.png'
import lastone from '../Assets/welldone/lastone.PNG'
import cor from '../Assets/welldone/cor.PNG'
import dube from '../Assets/welldone/dube.png'
import robotone from '../Assets/welldone/robotone.png'
import erm from '../Assets/welldone/erm.JPG'
import ohhump from '../Assets/welldone/ohhump.png'
import ohoh from '../Assets/welldone/ohoh.png'
import yuk from '../Assets/welldone/yuk.png'
import yukgot from '../Assets/welldone/yukgot.png'
import bud from '../Assets/welldone/bud.JPG'
import image64 from '../Assets/welldone/Image64.jpg'
import image65 from '../Assets/welldone/Image65.jpg'
import image66 from '../Assets/welldone/Image66.jpg'
import image67 from '../Assets/welldone/Image67.jpg'
import image77 from '../Assets/welldone/Image77.jpg'
import image78 from '../Assets/welldone/Image78.jpg'



const HighScores = ({mainBoxHeight, mainBoxWidth}) => {

	const [data, setData] = React.useState([])

	useEffect(() => {
		document.title = 'ROBOTRON - Well done';
	}, []);

	const textStyle = {color:"#0f0", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:20, letterSpacing:"3px", opacity:0.9, float:"left", textAlign:"left", textWrap: "wrap"}

	return <Box height={mainBoxHeight-160} width={mainBoxWidth-60} down={100} style={{paddingTop:20}} corner={0}>
		<div style={{...textStyle, width:mainBoxWidth-120, overflowY:"scroll", height:mainBoxHeight-220}}>
			<h1 style={{color:"#fff"}}>Well done for beating the game.</h1>
			<h2>Let me know if you want more here on <a href="https://discord.com/invite/wjVHhgGxj6">Discord</a>.</h2>
			<p>Originally we had a lot more plans. There were a ton of ambitous zones that we were realistically never going to get to.</p>
			<p><a href='/'>Killing Machine: Movement</a> took our time and work on Robotron was very sporadic over the years. When we picked it up again after the release of <strong>Movement</strong> a few more levels were added but the ambition was reigned in.</p>
			<p><h3>Here's a list of some of our old ideas for zones:</h3></p>
			<img src={rbtideasUpdated} alt={"ideas"} style={{width: "98%"}}/>
			<p><h3>And here are some more ideas and art we found in a old files:</h3></p>

			<p>LEVELS</p>
			<ul>
<li><p>sokoban</p></li>
<li><p>pacman</p></li>
<li><p>there should be a mode where you have RTS control of the enemies and you have to kill yourself</p></li>
<li><p>space invaders</p></li>
<li><p>dans shit</p></li>
<li><p>inside yourself fighting viruses</p></li>
<li><p><a href={"/games/necro35.zip"} download>necrophobia</a> (and maybe a <a href={"/games/runrun.zip"} download>run you lousy pedestrians</a> etc)there should also be the <a href={"/games/KOTIBCIS.zip"} download>invisible bouncy castle in space</a> and in a cutscene it is through robotron's eyes and he switches to ultraprovision or whatever and he can see it</p></li>
<li><p>there should be a zone or a series of zones where kirk has paradoxed you and you play in a really strange abstract represntation of a machine atttempting to understand a paradox</p></li>
<li><p>time stream zone</p></li>
<li><p>poem zone</p></li>
<li><p>monochromelolol</p></li>
<li><p>one zone should be you are martin luther king//it should be about the civil rights</p></li>
<li><p>one zone shold be a murder mystery, every level in the zone has a clue, and in the final level you have to kill the person you think did it and depending if you're right or wrong, you go to one zone or another</p></li>
<li><p>retroidzzzzz</p></li>
<li><p>enemies which split into 2 when you shoot them, (can't be destroyed but don't have to)</p></li>
<li><p>llamatron shit(zone?) -16ton weight, laser etc</p></li>
<li><p>breakout lolol</p></li>
<li><p>some kind of endurance (MLK speech) stage where enemies keep spawning</p></li>
<li><p>dance dance revolution w/ both wasd and arrows </p></li>
<li><p>STARCRAFT zone</p></li>
<li><p>legal//medical drama</p></li>
<li><p>erinsborough</p></li>
<li><p>PAR crossover (sigh)</p></li>
<li><p>NMNGH</p></li>
<li><p>lazarus</p></li>
<li><p>all the aggatrons at the same time</p></li>
<li><p>lightcycles</p></li>
<li><p>nazis</p></li>
<li><p>israel//palestine</p></li>
<li><p>neural energy//ANN (artificial neural network) energy</p></li>
<li><p>Rocketron zone</p></li>
<li><p>physics zone (lol)</p></li>
<li><p>3d (XY XZ YZ splitscreen/windows)</p></li>
<li><p>football/hockey</p></li>
<li><p>mr do </p></li>
<li><p>romantic comedy</p></li>
<li><p>snooker</p></li>
<li><p>alice in wonderland</p></li>
</ul>

<p>POWERUPS</p>
<ul>
<li><p>guns</p></li>
<li><p>snake</p></li>
<li><p>nova</p></li>
<li><p>smartbomb</p></li>
<li><p>zoom out</p></li>
<li><p>flamethrower</p></li>
<li><p>op420 drugs</p></li>
<li><p>betting (cointoss//poker)</p></li>
<li><p>Duplicate self</p></li>
<li><p>speedup (you)</p></li>
<li><p>speeddown (enemies)</p></li>
<li><p>javazon type gun</p></li>
<li><p>random proc gun</p></li>
<li><p>etherealise (prob should eth bullets too)</p></li>
<li><p>POWER PILL</p></li>
<li><p>blessed hammer</p></li>
<li><p>fire faster</p></li>
<li><p>extra time/ammo on other guns</p></li>
<li><p>destroy enemy bullets</p></li>
<li><p>maybe a splash damage powerup</p></li>
<li><p>a powerup that gives your bullets increidbly long range and makes them wrap like 2.5*screenwidth range</p></li>
<li><p>bouncing bullets (off walls, enemies)</p></li>
<li><p>a blaze-style powerup, makes your trail thing deadly to enemies or something</p></li>
</ul>

<p>ENEMIES/BOSs</p>
<ul>
<li><p>you from the past when you were evil</p></li>
<li><p>gel cube</p></li>
</ul>


<p>OTHER IDEAS</p>
<ul>
<li><p>outtakes</p></li>

<li><p>rocke on your shoulders</p></li>

<li><p>UNKNOWNality</p></li>

<li><p>you should give the blue obstacletrons mass and then have some enemies that are affected by them gravitationally</p></li>

<li><p>one specifically was that on the level based on Spock's Brain (or whatever), if you run out of lives, then when the level goes grey, another robotron should appear and kill everyone and then give you one of his lives then disappear. Then, 4 levels later, you go  back in time to that level and have to win it
and if you only have 1 life for example, then you give your only life to yourself establishing a closed time loop lol
if you have more than 1 life then you timeport back to the level 4 levels ahead.
ofc ifyou lose that level, then it goes back in time to that level and you only get the high score you had at that time</p></li>

<li><p>also at various points in the game there should be attempts made to explain wtf is going on</p></li>

<li><p>on the dancing stage, instead of being like you are some dancing to japanese pop, it should have a story, you are getting marrried but you are embarassed of your lack of dancing ability which will become evident at the wedding reception. you go to a dancing instructor to learn to dance, but then you fall in love//sleep with her
it would be like a romantic film or whatev</p></li>

<li><p>memories of meeting rocketron for the first time</p></li>

<li><p>when i say legal drama i don't mean some detective one or aynthing, i mean like you are being a lawyer for soem child abuser or something
and it's about the ethics of law</p></li>

<li><p>you should be able to get your musicianship to 100 and join dream theater and win</p></li>

<li><p>stock market</p></li>

<li><p>maybe there could be guitar-shaped powerups that don't appear to do anything, but once you have 1000 of thme (stored in ini file ofc) it unlocks a new zone//transition</p></li>

<li><p>one of the zones should be every ship called Enterprise before the NX-01
i mean, the firrst level is the first Enterprise, next is next etc
then another zone could be the enterprises starting with the nx-01
(up to JFAZW obv)</p></li>

<li><p>there should be a secret way to jump to the jfazw though which is ultra hard to find/requires grinding</p></li>

<li><p>at the start of RBT there is a cutscene and it says PREVIOUSLY... and it shows the cutscene from when you destroy robotron, then it says like a while later, adn shows the explosion backwards and then he turns good and shit because its got rid of aaaaaay's influence or someshit like that</p></li>

<li><p>there should be a (prob more than one) bit where robotron says his ultimate one liner catchphrase just before killing a boss in a cutscene</p>
<p>"what are you gonna do to me?!"</p>
<p>"UNKNOWN"</p>
<p>BAM</p>
</li>

<li><p>there should be an enemy who is a time-reaver (or some really lame name like that), who slows you down the closer you get to them, and if you get ultra close to them then you die, but their speed, rate of fire etc is always proportional to reciprocal of timespeed</p></li>

<li><p>there should be an enemy where it is someone is playing tetris and if you touch a block you die</p></li>

<li><p>if you get the splash damage one twice, it makes enemies killed by splash damage explode with splash damage as well
maybe with it being limited to amount its stackedf</p></li>
</ul>

<p><img src={torus2b} alt={"torus2b"}style={{width:"100%"}}/></p>


<p><img src={guild} alt={"guild"}style={{width:"100%"}}/></p>
<p><img src={twis} alt={"twis"}style={{width:"100%"}}/></p>
<p><img src={uuolin} alt={"uuolin"}style={{width:"100%"}}/></p>
<p><img src={twat} alt={"twa"}style={{width:"100%"}}/></p>
<p><img src={cor} alt={"cor"}style={{width:"100%"}}/></p>
<p><img src={dube} alt={"dube"}style={{width:"100%"}}/></p>
<p><img src={ohhump} alt={"ohhump"}style={{width:"100%"}}/></p>
<p><img src={ohoh} alt={"ohoh"}style={{width:"100%"}}/></p>
<p><img src={yuk} alt={"yuk"}style={{width:"100%"}}/></p>
<p><img src={yukgot} alt={"yukgot"}style={{width:"100%"}}/></p>






<p><strong>
The Hairy Unwelcome Balls says (12:32):</strong>
</p>
<p>
btw, you know how i was saying there should be an enemy that always drops a powreup, and that picks up powerups and then drops them when you kill him
</p>
<p>
that enemy could actually get the power from the powerup iyl
</p>
<p>
that would be very cool, though that shouldnt be the gel cube
</p>
<p><strong>
want to playtest robotron?? says (12:32):</strong>
</p>
<p>
would be cool
</p>
<p>
maybe a boss does tha
</p>
<p><strong>
want to playtest robotron?? says (12:33):</strong>
</p>
<p>
a clone of you or something
</p>
<p>
or you from the past when you were evil
</p>
<p><strong>
want to playtest robotron?? says (12:34):</strong>
</p>
<p>
when you kill yourself in the past the timeline fucks up and you get sucked into a temporal anomaly and thats the time zone
</p>

<p><img src={digrade} alt={"digrade"}/></p>
<p><img src={dunka} alt={"dunka"} style={{width:"100%"}}/></p>
<p><img src={holup} alt={"holup"} style={{width:"100%"}}/></p>
<p><img src={hyperjuice} alt={"hyperjuice"}/></p>
<p><img src={rased} alt={"rased"}/></p>
<p><img src={rentilled} alt={"rentilled"}/></p>
<p><img src={tamer} alt={"tamer"}/></p>
<p><img src={tase} alt={"tase"}/></p>
<p><img src={lastone} alt={"lastone"}/></p>
<p><img src={robotone} alt={"robotone"} style={{width:"100%"}}/></p>
<p><img src={erm} alt={"erm"}/></p>


<h3>Here are some character bios</h3>

<h4>Robotron </h4>
<h5>Prior Rocketron: </h5>
<p>
	Soon after Queen Soe Doe Mae took control of the royal guard, which no longer had jurisdiction over the mob ruled world, he conceived the Robotron project as an early move against Dr. The G Person and aaaaaaaaaaaaaaaaaaaaay. However, after numerous prototypes, Queen Soe Doe Mae got bored and focused on other projects. The current version of Robotron was used as a surveillance model and was recognised among many communities as a helpful observer of society, often aiding in construction and civil conflict situations. Robotron would often visit Rocke T Ron and investigate the progression of his blueskin race. Something Rocke felt privileged by.   Something deep within Robotron yearned for awakening. A potential and force that had not been calculated or intended by his creators. One day, Robotron was ordered by Queen Soe Doe Mae to collect a series of green squares across the world. Robotron abided and had soon taken all the green squares accessible to him. Awaiting further orders, Robotron learned from Queen Soe Doe Mae that Rocke had been given a similar assignment and had also collected most of his green squares. However, Rocke was a problem in the eyes of Queen Soe Doe Mae and he ordered Robotron to meet Rocke, kill him and steal his squares. Although initially reluctant to follow, Robotron's loyalty never fell short and he went to fight Rocke to the death.
</p>
<h5>Post Rocketron: </h5>
<p>
	Aaaaaaaaaaaaaaaaaaaaay, having had his green squares stolen, led Rocke and Robotron into a portal trap somewhere deep in Dr. The G Person's main reactor. There, he proceeded to take care of both his enemies. aaaaaaaaaaaaaaaaaaaaay turned Robotron haywire and left him and Rocke to destroy each other. A long battle was fought and limbs and weapons were slowly lost. Eventually, Robotron was defeated with an expansive explosion which caused him to lose his power source and green squares to Rocke. It was not long however, till the remnants of Robotron were collected by Dr. The G Person, retaining the valuables of his soon to be destroyed main reactor. Dr. The G Person returned to the reclusive depths outside of the public eye where he plotted and planned for his return to dominance. The reproduction and improvement of Robotron was among some of these plans for a redeeming future. YOUSLUTCUNT? helped repair Robotron and installed one of the few surviving F-tron chromostrons Dr. The G Person possessed. Robotron's destiny was integral to the shaping of the unstable world. Then one night, a mysterious voice echoed and Robotron was prematurely turned on. Compatible with many weapons and upgrades found in the world and parallel worlds, the voice reminded the sentient robot that his power was not to be neglected. Robotron exited the apparent dormant factory and faced the hostile world.
</p>


<h4>Rocke T Ron </h4>
<h5>Prior Rocketron: </h5>
<p>
	Born to a whore of Hookerville, the unwanted blue freak child, Rocke T Ron was sent to the lands of level 1. There, he grew strong as did his reputation as a fierce warrior. Rocke also gained respect as a pioneer of the blueskin race research, discovering the reason for this powerful groupof beasts. Rocke stood out from the rest however due to his heritage as a divine warrior. This was information that he later discovered via mysterious scrolls. News of this nobility spread and soon enough, communication travelled to Queen Soe Doe Mae, who orchestrated a manipulative plan to get Rocke on his side. Rocke was familiar with Queen Soe Doe Mae as he recognised him as one of the three in a conflicting struggle for control of the town between him, aaaaaaaaaaaaaaaaaaaaay and Dr. The G Person. He trusted Queen Soe Doe Mae more, as Queen Soe Doe Mae had worked for the true royal rulers as chief eunuch. Queen Soe Doe Mae 
had also been responsible for the construction of Robotron, a blueskin sympathiser who often came to visit and aid in blueskin peacekeeping and civil production. The two would often converse about issues and the nature of events. One day, Rocke came across The Cool Guy carrying a rocket launcher and grenades. A battle was instigated and Rocke soon realised he was immune to explosions and falls. After Rocke defeated The Cool Guy, an angel, Nortoaf appeared before him and convinced Rocke of the destiny he had been searching for for so long. The green squares under control of those corrupt few who have poisoned the land with devastating squares held the redemption and cleansing that this world needed and Rocke T Ron was the one who had the responsibility to collect them all together. Endowed with purpose, Rocke began his quest.
</p>
<h5>Post Rocketron: </h5>
<p>
	Having been simultaneously participating in a similar mission on the other side of the earth to cut time, Robotron too had collected all of his green squares. One remained but before they were all combined together, Robotron was sent to kill Rocke T Ron. The two however were led into a trap arena by the observant aaaaaaaaaaaaaaaaaaaaay who had been monitoring them ever since.   aaaaaaaaaaaaaaaaaaaaay turned Robotron haywire and left the two to battle it out to the death. Overcoming his initial reluctance to fight, Rocke destroyed Robotron and combined the green squares. However, it was then that Rocke learned the truth about his manipulation but it was too late. The evil force of F-tron was released and Rocke had no choice but to prevent him from walking the earth. He fought well and eventually F-tron, in his final albino form, fell. Rocke walked off to notify the townspeople but before he saw a single soul, F-tron's spirit took him over and brought him under his control. Now used as a puppet to turn the enemies of F-tron against each other, Rocke is a greater danger than any other mortal. Hope looks lost for Rocke but his spirit clings on. There is still a flame, a spark, a part of his soul that rages beneath F-tron and it yearns to be let out.
</p>


<h4>F-tron </h4>
<h5>Prior Rocketron: </h5>
<p>
	Everything, shit and evil is personified as F-tron, forged in the flames of hell at the dawn of matter. As one of the three prime evils, F-tron resided in hell for billions of years and wasresponsible for many events that stunted the evolution of the earth until F-tron was ousted fromhell by a group of lesser demons. F-tron was thrusted in the purgatory plains, an endless span of nothing. Whilst drifting through the void, F-tron encountered the Riths. A race intent on destroying all, and intent only to reach and inhabit a world they can destroy again and again until the only thing in existence is their hunger. F-tron took advantage of the Riths’ hunger and convinced them to help him back to hell. Once returned, F-tron slaughtered all the demons in hell as well as the Riths. However, F-tron hatched an idea. F-tron had always wanted to take earth and its towns for himself. There he could be shit to loads of victims but he had to weaken the earth's defenses beforehand. He couldn't do it by himself. If he could somehow convince the Riths that to pay them back for helping him take hell from the rogue demons, he would release them from purgatory and let their hunger feast on the earth above. That way the Riths would surely be destroyed with F-tron's debt cleared and earth's defenses weakened, allowing him to finish them off. Sure enough, the Riths were destroyed by earth's warriors. Now it was time for F-tron to rise. This guy attacked earth with his army of remaining demons but F-tron had made the mistake of underestimating earth's defenses and the divine warriors forced F-tron to retreat away from the main town. F-tron rested with his army and built up strength for a second attack. He needed to make sure that the divine warriors who stopped his advance were taken care of so he used his angel Nortoaf to convince one of his worshipers on the inside to kill them for him. With the warriors dead F-tron was ready for a second attack. It was then that Dr. The G Person's squares engulfed the hell army and killed them. F-tron was almost defeated too until he was approached by Dr. The G Person himself and his business partner YOUSLUTCUNT? In exchange for F-tron's 
life to be spared, Dr. The G Person wanted some of F-tron's clone serum for a new hellish weapon he wanted to invent. F-tron agreed and gave the criminals 47 chromostrons of clone serum. Dr. The G Person kept his end of the deal but to twist his words, he encased F-tron in the mystical confinement of the mysterious green squares. F-tron burned with rage inside his prison, waiting for his day of release. But meanwhile on the surface, a survivor of F-tron's army was plotting for his revenge on the world. Taking advantage of the chaotic mob rule where anything goes, Nortoaf prepared a manipulative plan with her high ranking chess piece on the board, Queen Soe Doe Mae and countless victims.
</p>
<h5>Post Rocketron: </h5>
<p>
	As the final green square was collected, F-tron encountered the first being he had seen in years, Rocke T Ron, the blueskin divine descendant who unwittingly released him. A series of epic battles ensued and as F-tron transformed into his ultimate true form, Albino F-tron, Rocke dealt the final blast. Rocke left F-tron's domain, foolishly confident that he had crushed evil. F-tron however, had used a desperate technique, wherein he could consume the essence and possess the vessel of an unfortunate victim. The body could only sustain form in the material realm if F-tron's power and strength was low enough to not exceed the potential of the vessel. With F-tronweakened during the fight with Rocke, this was easily accomplished. Now roaming the lands of men, F-tron used the opportunity to survey his upcoming arena and pre-position some playing pieces before he chose to fully recover. Calling his army together as well as the townspeople, blueskin race and royal guards who respect this apparent legendary descendant who took down F-tron, the possessed Rocke used his position of influence to convince and turn the tables on those who betrayed him. Setting a plan in motion, F-tron's soldiers headed for the exile Dr. The G Person and the retaliatory aaaaaaaaaaaaaaaaaaaaay.
</p>


<h4>Dr. The G Person </h4>
<h5>Prior Rocketron: </h5>
<p>
	Dr. The G Person started his career as a humble defence vendor. An early creation of his was the right click cluster grenade rocket, a project he never took further than a simple prototype with limited ammunition. His skill and corrupt actions had him rise to an influential position within the criminal underground. This was also due, in some part, to his main propagandist YOUSLUTCUNT? The two made a good team and in time, Dr. The G Person's name had spread to the ears of world leaders. During their time of desperation, where their divine army had been desecrated, the royal leaders and their people turned to Dr. The G Person and his mob for help. With their army defeated, F-tron had few obstacles in his way before he took earth. With a grant from the government, Dr. The G Person bought many factories and proceeded to move into mass production. Combining the rebel and criminal conglomerates, Dr. The G Person moved his squares into position, engulfing the majority of F-tron's army in little time. F-tron was at the townspeople's mercy until he was approached by YOUSLUTCUNT? and Dr. The G Person himself. In exchange for F-tron's life to be spared, Dr. The G Person wanted some of F-tron's clone serum for a new hellish weapon he wanted to invent. F-tron agreed and gave the criminals 47 chromostrons of clone serum. Dr. The G Person kept his end of the deal but to twist his words, he encased F-tron in the mystical confinement of the mysterious green squares.
</p>
<p>
  The world may have been spared from F-tron's abuse, but it was now left in ruin and littered by masses of ugly right angled evil. Mob rule was law and order and it was not debated who was at fault. Dr. The G Person bought many soldiers over the years of his reign, mostly from competitors and mostly minorities. He could have stayed on top for a lot longer but due to his high status and mumbling demeanor, too much distance and not enough communication caused conspiring within the ranks. Within years of establishment, rogue subordinate factions had stolen products from Dr. The G Person and began moonlighting with their own separate produce. aaaaaaaaaaaaaaaaaaaaay whispered lies into YOUSLUTCUNT?'s ear. Intent to bring the 
business down from the inside and make a name for himself as a branch faction, aaaaaaaaaaaaaaaaaaaaay convinced YOUSLUTCUNT? that Dr. The G Person was screwing them over and that they weren't getting a fair cut. YOUSLUTCUNT? broadcasted that Dr. The G Person was responsible for the state of the earth and its ridiculous amount of squares, which was true. When the public heard of these and other claims of corruption, Dr. The G Person's sales decreased and his workers took over and split up. Dr. The G Person's influence was crippled.
</p>
<p>
As he remained hidden in the shadows, Dr. The G Person saw his empire crumble around him. Red square safety measures and law enforcements. The Cool Guy was one of the few soldiers to stay loyal to Dr. The G Person and it was he who was entrusted with the rocket launcher. The weapon that would lift Dr. The G Person to the top, in all senses. But a conspiring force brought together a chance meeting that had his weapon of prestige taken. Blue it up.
</p>
<h5>Post Rocketron: </h5>
<p>
	Rocke T Ron had collected the final green square, located in the depths of Dr. The G Person's reactor. The result was F-tron's release. While Rocke was left to immediately redeem the situation, Dr. The G Person found the remnants of the destroyed Robotron. Once again, he retreated into the shadows.
</p>
<p>
	Dr. The G Person got to the top because he earned his place. He has the skills to do it again despite his betrayal and corrupt actions during his rise to power. Such acts as spreading squares and weapons throughout this land. He will always be the best in weapons development regardless of how many blue squares aaaaaaaaaaaaaaaaaaaaay has produced or how much land he has. Years later, Dr. The G Person has now moved into training warriors and soldiers, now that he has outfitted them with weapons. Soldiers such as Female, The Cool Guy and the newly rebuilt Robotron that he had repaired. Dr. The G Person had also retaken YOUSLUTCUNT? under his wing, who offered himself as an experiment subject. The F-tron clones (spawned from the serum intended for Dr. The G Person's hellish weapon.) had broken free from his reactor when Robotron destroyed it. However, five serums survived the blast and were collected to be used on YOUSLUTCUNT?, Female and perhaps Robotron. He also intends to install the serum into a surviving warrior from the F-tron battles but the only one he can think of who's still alive is Trunky Trunky Funk Funk. 
</p>
<p>
In order to engage his plans, Dr. The G Person has pushed forward slowly, breaching the rules on red square production, developing new moving shooting ones as well as posting The Cool Guy and YOUSLUTCUNT?'s men in occupied areas. Mining for red square synthetic under the earth’s ground and harnessing his newly acquired portal world transferring power, Dr. The G Person is climbing back on top. Fast.	
</p>

<h4>aaaaaaaaaaaaaaaaaaaaay  </h4>
<h5>Prior Rocketron: </h5>
<p>
	aaaaaaaaaaaaaaaaaaaaay worked under Dr. The G Person. A subordinate low on the hierarchy of weapon and square production. Jealous of Dr. The G Person's power and influence, aaaaaaaaaaaaaaaaaaaaay plotted in the shadows. He had come across the F-tron chromostrons, which were currently being made into F-tron clones. This is how he conceived the idea of mass produced blue squares. However, even if he didn't want all of the production power for himself, Dr. The G Person would not have allowed him to invest in such an inferior product. aaaaaaaaaaaaaaaaaaaaay worked his way up a chain of moonlighting delegates and convinced YOUSLUTCUNT? that Dr. The G Person was neglecting his entire work force. As Dr. The G Person's span of control shrunk, aaaaaaaaaaaaaaaaaaaaay took up the cheap and automated blue square mass production. He is still the best in the field of square production. That combined with a number of Green squares he had captured helped aaaaaaaaaaaaaaaaaaaaay gain leverage over the city, disregarding any ruin that would arise as a result.
</p>
<h5>Post Rocketron: </h5>
<p>
	aaaaaaaaaaaaaaaaaaaaay had kept a close eye on Rocke T Ron ever since he stole a green square from him early on during his adventure. Robotron had also been stealing green squares under the order of Queen Soe Doe Mae. The three met in a secret area near Dr. The G Person's main reactor. Using his weapons programing and the opportunity of Rocke and Robotron in the same area, aaaaaaaaaaaaaaaaaaaaay turned Robotron haywire, and the two fought against each other. However, Rocke survived and went on to fight and subsequently become possessedby F-tron when he defeated him. This double agenda Rocke pointed the public’s fingers of blame towards Dr. The G Person and aaaaaaaaaaaaaaaaaaaaay, producers of the squares who had defeated him before. The town’s people revoked. Rather than convince them otherwise, aaaaaaaaaaaaaaaaaaaaay invested on mother and homing blue squares and sent them throughout the world to attack any against him.
</p>
<p>
	Realising he needed temporary allies, aaaaaaaaaaaaaaaaaaaaay hired El Ho Gigolo to protect his DNL island factory and also made a temporary alliance with the mysterious Margor, who approached him one night to take vacancy on the island. aaaaaaaaaaaaaaaaaaaaay, for now, believes his position is fortified.
</p>


<h4>The Cool Guy </h4>
<h5>Prior Rocketron: </h5>
<p>
	A skilled fighter and fierce warrior. The Cool Guy was rumored to be a descendant of the fabled noble divine warrior bloodline. However, this was later disproved. The Cool Guy was one of many who worked under Dr. The G Person. While others moonlighted, The Cool Guy remained loyal. Dr. The G Person's impending subjugation to betrayal was on the horizon and he knew it. Entrusted to protect his green squares during his empire's collapse, The Cool Guy was handed the rocket launcher by Dr. The G Person, who designed it specifically for him, as The Cool Guy was immune to falls and explosions. 
</p>
<p>
	Dr. The G Person's empire had crumbled and he hid in the shadows while his few remaining minions carried out his orders. While delivering grenades and the advanced rocket launcher to intended mob bosses, The Cool Guy was ambushed by Rocke and Nortoaf. After waking up to his absent stolen items, The Cool Guy recalled and recognized Nortoaf, the angel. He realized that Queen Soe Doe Mae would have been in the best position to organize the ambush, so as to keep Dr. The G Person down in the gutter. Burning with rage, The Cool Guy began hunting for Rocke
</p>
<h5>Post Rocketron: </h5>
<p>
	The Cool Guy wants to bring the square manufacturers together again, for what reason is unknown. His loyalty to Dr. The G Person is now slightly in question but he still persists with his work. Grouping all of his playas together, The Cool Guy senses the time is right for his team to strike back and take what is rightfully his. Little does he know that he too may be hunted. 
</p>


<h4>Queen Soe Doe Mae </h4>
<h5>Prior Rocketron: </h5>
<p>
	When the world had appointed royal rulers, Queen Soe Doe Mae was chief eunuch. He is a fucked up individual who resented his superiors and abused his place in society. He would frequently sacrifice cute soft bunnies in F-tron worshiping rituals. During his time as chief eunuch, he learned how to communicate with angels, a skill that would have got him killed if his royal 
rulers ever found out. Fearing the loss of his power, Queen Soe Doe Mae kept in contact with F-tron's arch angel Nortoaf, who told him that F-tron and his army was approaching and that he had to intervene with the resistance. The divine warriors assembled to defend the world fromF-tron and his hellish army and they did successfully. F-tron, losing many, retreated, intending to lead the warriors into a trap. Assuming this was the case, the divine warriors took rest within the royal grounds instead, hedonistically enjoying their coke and eunuchs. It was then that Queen Soe Doe Mae led the eunuch revolt and had all of the warriors slaughtered. However, one survived and escaped into the town. Queen Soe Doe Mae's idol F-tron would have taken over if it had not been for the townspeople and their desperate alternative. Turning to Dr. The G Person and his mob, the squares took F-tron's army and imprisoned him.
</p>
<p>
	   The enemy that now stood in his way was Dr. The G Person. However, Queen Soe Doe Mae was not worried. Nortoaf reassured Queen Soe Doe Mae, stating that just as he himself had done to his superiors, Dr. The G Person's workers would turn against him. And they did. Now Queen Soe Doe Mae's mission, aside from bidding for control over the city with aaaaaaaaaaaaaaaaaaaaay, was to release F-tron from his green square prison. Nortoaf advised that Queen Soe Doe Mae's powerful invention Robotron should acquire the squares alongside the newly discovered powerful divine warrior descendant, Rocke T Ron, who they would have to trick into doing so. Observing The Cool Guy and the protection he offered for the green squares under Dr. The G Person with his rocket launcher, Queen Soe Doe Mae set an ambush in motion.
</p>
<h5>Post Rocketron: </h5>
<p>
	Both Robotron and Rocke T Ron had collected all but one green square. It was Queen Soe Doe Mae's own idea to have the two fight each other and earn the right to free F-tron and if so inclined, attempt to fight him too. The victor of both battles was Rocke but in his true form, F-tron possessed the blue pawn. His lord F-tron walks the earth. Not in the form he or his followers envisioned but nevertheless. Not as awe inspiring as hoped and definitely not as rewarding, Queen Soe Doe Mae has a whole castle of royal guards, eunuchs and worshiping alters for other entities at his disposal. Besides, the townspeople's attention is turned away from him towards this mob city. The fickle whims of a traitor by nature, if he is given any incentive. His intentions may be justified though, since F-tron has awoken, what use is the queen to him any longer?
</p>


<h4>YOUSLUTCUNT? </h4>
<h5>Prior Rocketron: </h5>
<p>
	YOUSLUTCUNT? was Dr. The G Person's most trusted propagandist and he loyally helped him construct his empire. As word of Dr. The G Person and his weapon production spread, so did his influence. More employees grew underneath him and Dr. The G Person concentrated on certain priorities. The rulers of the city came to Dr. The G Person demanding his help as their warriorswho had fought against and almost defeated F-tron had all been slaughtered by an inside force. Given the funding he needed, Dr. The G Person bought factories and went into mass production. Soon enough his squares had all but destroyed the remains of F-tron's army. F-tron was on his knees before Dr. The G Person as he and YOUSLUTCUNT? approached F-tron offering a proposition. If F-tron were to give Dr. The G Person 47 chromostrons for a new hellish weapon, then his life would be spared. He did so but to twist his words, Dr. The G Person imprisoned F-tron in the multiple confines of the green squares.
</p>
<p>
Witnessing Dr. The G Person's corrupt and immoral dealings, it did not take much for the greedy aaaaaaaaaaaaaaaaaaaaay to convince YOUSLUTCUNT? that Dr. The G Person was cheating them all out of what they truly deserved. In response, YOUSLUTCUNT? broadcast to the world the truth that Dr. The G Person was the one responsible for the state of the square infected landscape. Sales decreased and the empire they had built together as a team began to unravel. Realising how he too had been manipulated by aaaaaaaaaaaaaaaaaaaaay's lies, YOUSLUTCUNT? suffered from a guilt overdose and went into a korma. Every day from then on, 
he stepped on the edge of whether he could be mistakenly eaten or not.	
</p>
<h5>Post Rocketron: </h5>
<p>
	While rebuilding his empire, Dr. The G Person found YOUSLUTCUNT? in his korma and took him under his wing once more. As a sign of servitude, YOUSLUTCUNT? agreed to be experimented on for the sake of weapons development, which Dr. The G Person had no objection to. As well as research on his unstable korma vessel, YOUSLUTCUNT? harnesses one of the five remaining F-tron chromostrons, the weapon that will appear as a result has not yet shown itself. Since then YOUSLUTCUNT? had sent his men and propaganda billboards out once more to spread better communication and has also helped rebuild the discovered remnants of the machine Robotron.
</p>


<h4>Trunky Trunky Funk Funk  </h4>
<h5>Prior Rocketron: </h5>
<p>
	Also known as T2F2, Trunky Trunky Funk Funk began as a freelance assassin. Hired by mob bosses, he was amongst the best and still had a high respect for the old mystical ways. Soon enough, a Rith army appeared on the horizon threatening the world. Suggestions were made. T2F2 was hired by the townspeople and effectively took down the army of Riths with a group ofwarriors of which survivors would later become the divine warriors. They defeated the Riths before they crossed the level 3 gateway further into town. However, the holy lands of level 2 were heavily damaged by the Riths.
</p>
<p>
	When T2F2 had returned with news that the Riths had been wiped out along with three horsietrons of ancient treasure, T2F2 was showered with respect and reputation. He was awarded a position as head conductor guy overlooking the Beaseige Towers, while the otherswere provided whores and coke and loyal never betraying eunuchs in exchange for protection of the earth from the upcoming F-tron and his hell army invasion. Upon witnessing the corruption of many men of power that he had served, T2F2 made sure not to let his status go to his head. T2F2 chose to donate to a good cause and used his philanthropic power to rejuvenate and construct a conveyor machine where the ruins of level 2 had been. This conveyor machine had two purposes. It powered most of the underground systems and also provided a stronghold with strengthened barriers to secure one of the many mysterious green squares. He got cervix cancer. 
</p>
<p>
	He didn't die. The once proud freelance assassin was too weak to fight or to make a difference anymore. He was forced to be nursed away hidden in his Beaseige Towers while he watched and heard his fellow warriors get slaughtered and his world transform and die before him.
</p>
<h5>Post Rocketron: </h5>
<p>
Strengthening his body gradually with TNF cytokine, T2F2 was able to operate machinery and vehicles close to the top of his tower. He knows that the world is in a bad situation and still in danger from an evil force. The feeling comes to him, that he will help the fight again. That and the sign sent to him most days. The numerous helicopters and men sent to the Beaseige Towers by Dr. The G Person to capture him and use him for his chromostron weapon.	
</p>


<h4>Cheers Du Beer </h4>
<h5>Prior Rocketron: </h5>
<p>
	Upon establishing his illegal mass trade system in level 4, Cheers Du Beers questioned the efficiency of his well-regulated trading routes. Cargo vessels and commuter transplotrons had the 
freedom to travel across both the short-hard way and the long-easy way for business purposes. Realising profit could be made from this, Cheers Du Beers set up multiple chemists across level 4. News spread of the chemists and their miracle cure and soon many people came to inquire about and visit them. Unfortunately for the guy, the tourists and visitors who came to inspect the shit, caused congestion for the transport routes and a safety measure had to be installed for the tourists and the illegal cargo vessels that passed by. Thus, Du Beers purchased moving red squares from Dr. The G Person to protect the illegal cargo that was transported via the short-hard route from tourists. Du Beers also created the moving purple squares to provide foreigners means to visit the chemists. However, one day, Du Beers was dead.
</p>
<h5>Post Rocketron: </h5>
<p>Or was he?
	
</p>



<h4>Nortoaf  </h4>
<h5>Prior Rocketron: </h5>
<p>
	Angels have been depicted as god's servants in many of the murals seen in the world. However, according to the original myths, angels were not to be trusted. They were divine manipulators who conspired to force mortal peons to do their bidding on earth. Frequently summoned by chief eunuch Queen Soe Doe Mae, Nortoaf, F-tron's elite angel, together with her reputation, would plot F-tron's uprising in the shadows. It went well for the majority of the time. The Riths had been destroyed by the world’s defenses, weakening them in the process and clearing the debt F-tron had with the Riths. However, the divine warriors were not as fatigued as once thought and they pushed back F-tron's attacking army just as quick. Instead of pursuing F-tron, the divine warriors assumed a trap would be laid for them if they followed in pursuit. As such, they decided to stay in their castles and celebrate and rest. It was then when Nortoaf convinced Queen Soe Doe Mae to slaughter the warriors from the inside. All but one fleeing divine warrior survived. Even so, F-tron still tasted defeat at the hands of Dr. The G Person, the townspeople's second resort. F-tron's essence was trapped in the multiple green squares, of whom Dr. The G Person owned the majority. 
</p>
<p>
	Nortoaf did not worry about capturing the green squares for she knew the weak corrupt souls of men. In time, as she predicted, Dr. The G Person was brought down and the world was left under the care of established criminals. Nortoaf advised that Queen Soe Doe Mae's powerful invention Robotron should acquire the squares alongside the newly discovered powerful divine warrior descendant, Rocke T Ron, who they would have to trick into doing so. Observing The Cool Guy and the protection he offered for the green squares under Dr. The G Person with his rocket launcher, Nortoaf set an ambush in motion. When Rocke and The Cool Guy encountered each other, a battle ensued. Just as intended, Rocke emerged victorious. Nortoaf appeared before him and the slightly conscious The Cool Guy. The holy manipulation convinced Rocke to head off in search for the mysterious green squares. 
</p>
<h5>Post Rocketron: </h5>
<p>
	Abandoning Queen Soe Doe Mae, Nortoaf returned to the now free F-tron. In order to test who shall rightfully rule this earth, a great war must commence and Nortoaf has many spiritual entities and soldiers to do the job. Only when the time is right. 
</p>

<h4>Female </h4>
<h5>Prior Rocketron: </h5>
<p>
	Brought up on the outskirts of both Hookerville and level 6, Female had connections with both whores and criminal businessmen. Both sides wanted her as a playing piece. However, it was Dr. The G Person who found her during his accent to fame. He employed her to keep in contact with and maintain the professional relationships with his criminal elite partnerships. Such included the 6 dark and various Mafioso. It was thanks to Female that Dr. The G Person received the funding for his new rocket launcher in his time of need. The mob however, required payback for this gift.
</p>
<h5>Post Rocketron: </h5>
<p>
After Rocke T Ron's devastating theft and crusade for the green squares, the mob demanded blood for Dr. The G Person's unpaid debt. While Dr. The G Person was planning his return with The Cool Guy, YOUSLUTCUNT? and the repaired Robotron, Female, who worked well with the Cool guy, concentrated more on the criminal side of activities. Using her great bargaining skillsand delegation, Female calmed the mob and maintained their vengeful rage at a steady level. Although she appears to have things under stable control, deep inside, she yearns for something more.	
</p>

<h4>Divine Warrior Survivor </h4>
<h5>Prior Rocketron: </h5>
<p>
	Life was good. Having returned from fighting off the Riths with T2F2, the divine warriors succeeded in fighting off F-tron and his army who followed soon after. Weary of a trap laid by F-tron if they followed in pursuit, the divine warriors appointed by the kings, returned to the holy lands to celebrate and drink with their whores, coke and eunuchs. It was that night a dark plot came to completion and Queen Soe Doe Mae's eunuchs slaughtered all but one of the divine warriors. Wounded, the remaining warrior fled the holy land. He took refuge in the crime enveloped city while the war against F-tron was being finished off by Dr. The G Person and his criminal underworld. Whilst in exile in Hookerville, the warrior got loads of whores pregnant so that his genetic ownage could live on. Next, he got crushed by a giant five Brazilian ton tumor in a freak square detonation accident. What a dumbass. His statue still stands to this day
</p>

<h4>Margor The Penumbraduke </h4>
<h5>Prior Rocketron: </h5>
<p>
	Margor awoke with life long after the epic stellar battle between the Mengarites and Serpenski's. He grew strong and was educated intensely. Staying close to The Mengarite Ruler, Margor based his life around honour and virtue. Although his morality differed from the outlooks of modern convention, he stuck true to his principles. Soon it was time however to return to earth and awaken the forces buried there long ago.
</p>
<h5>Post Rocketron: </h5>
<p>
	In order to not disturb the current state of earth, only a few of the Mengarites were sent to the surface and maintained a low profile. Margor was among these few. He returned to the fabled tribe island where a town had been built and aaaaaaaaaaaaaaaaaaaaay had built a DNL factory. Margor approached aaaaaaaaaaaaaaaaaaaaay with a proposition in order to secure a temporaryplace on the island. Now Margor slowly prepares for the alien tribal return while an army of invaders await on the outskirts of the skies.

</p>

<h4>El Ho Gigolo </h4>

<h5>Post Rocketron: </h5>
<p>
	Much like Trunky Trunky Funk Funk, El Ho Gigolo was known as a hired killer. aaaaaaaaaaaaaaaaaaaaay, in need of allies in his war against the town people, employed El Ho Gigolo full time to guard his DNL factory. Although not as elite and skilled as T2F2, El Ho Gigolo quickly gained a reputation of danger. Fast and deadly, he equips himself with dual python revolvers and thanks to aaaaaaaaaaaaaaaaaaaaay's inventiveness, they can harness the destructive power of the F-tron inspired blue squares.
</p>

<h4>Mob Greyhound </h4>

<h5>Post Rocketron: </h5>
<p>
	A protégé under the 6dark, Greyhound is a silent unstoppable monster. After the mob's funding for Dr. The G Person's rocket launcher was not repaid, Greyhound relentlessly contributed to thedestruction of what remained of Dr. The G Person's empire. Now that Dr. The G Person's forces are rising again, Female, a soldier serving underneath him has repeatedly advised against the mob, for them to cease their criminal campaigns against Dr. The G Person. As a result, the mob staged a façade, that they would curtail actions against Dr. The G Person. But this was only after Greyhound learned of The Cool Guy through Female and went off after him on his own. It is only a matter of time, due to The Cool Guy's thirst for Rocke T Ron, that Greyhound can lead The Cool Guy into a trap himself. Perhaps this business is too big for the mob. 
</p>

<h4>The Land Guardians </h4>

<h5>Post Rocketron: </h5>
<p>
	Thought only to be part of fabled superstition, the late royal rulers spoke of nature guardians who lived bellow the earth and would rise when upset. Soulless and the personifications of pure power, certain natural disasters are growing more frequent and an omnipotent force rumbles bellow the horizon of this square littered land. 
</p>

<h4>Divine Descendants </h4>

<h5>Post Rocketron: </h5>
<p>
	Since the announcement of Rocke's divine bloodline, a mysterious individual has claimed that due to the high number of whores impregnated by the lone surviving divine warrior, many more descendants must remain and that he is one of them. Although some may be deluded about their identity, a group has amassed, intending to reclaim the royal guard and its rightful rule. This mysterious individual may be credible in his intentions as he has seen through Rocke's broadcast to the world and identified him a possessed foe with demonic grace.
</p>

<h4>The Mengarite Ruler </h4>
<h5>Prior Rocketron: </h5>
<p>
	A Mengarite as old as F-tron, whom he became very familiar with at the forming of the earth. Part of an ancient holy alien tribe, The Mengarite Ruler and his race fought a stellar battle between another alien race known as the Serpenskis and the Prime Evil demons. Over centuries, Mengarites relocated and expanded over the local solar system, bringing down the serpenskis. Not before however, burying their wounded and weak bellow the earth, recovered and nourished by the purity of the internal earth. Until their return, the Mengarites set off in search for their true lord.
</p>
<h5>Post Rocketron: </h5>
<p>
The time to return to earth was soon but The Mengarite Ruler in all his blunt nihilistic approaches, halted the careless inhabitation of earth in case it disturbed its current balance. Instead, Margor was sent to initiate the return of the fallen, stronger than The Mengarite Ruler and more ruthless in their search for truth and perfection.	
</p>


<h4>The Prime Evils </h4>
<p>
	Rumoured to be called GFC and NGJ, the other prime evils, too created at the dawn of conception, are far more stronger than F-tron and care not for his immature desperation for power. They do have engagements but far more sinister and resulting in a far more permanent form of closure. 

</p>


<h3>Heres some more stuff</h3>

<img src={bud} alt={"bud"} style={{width: "100%"}}/>

<p>So that picture is from my trip to Japan in 09. I guess RBT was a thing then. Thought that (originally as a party member for rocketron 2) when he finally gets invincible mode, he kinda grows azillion arms with different shit. And you kind of realise he’s already in the lotus position.</p>



<img src={image64} alt={"image64"} style={{width: "100%"}}/>
<img src={image65} alt={"image65"} style={{width: "100%"}}/>
<img src={image66} alt={"image66"} style={{width: "100%"}}/>
<img src={image67} alt={"image67"} style={{width: "100%"}}/>
<img src={image77} alt={"image77"} style={{width: "100%"}}/>
<img src={image78} alt={"image78"} style={{width: "100%"}}/>

<h2>The original script</h2>
<div className={"script"}>

<h3>
Missing DR. THE G PERSON'S tutorial
</h3>
<h4>MYSTERIOUS VOICE (V.O.)</h4>
<p>Welcome Tron</p>
<p></p>
<p>Enter Music:</p>
<p></p>
<p>ROBOTRON starts up and can see through his green eye sight thing.</p>
<p></p>
<h4>MYSTERIOUS VOICE (V.O.)</h4>
<p>You have entered a time of unrest. The oppressed are taking what they shouldn't back and the plague of squares are ever evolving.</p>
<p></p>
<p>Peasant resistance mobilise and red and blue squares move across them.</p>
<p></p>
<h4>MYSTERIOUS VOICE (V.O.)</h4>
<p>An invasion from outside this world. And from within.</p>
<p></p>
<p>Mengarites and goliath4 move outside the earth. Temple guardians and demons emerge from the dark ground.</p>
<p></p>
<h4>MYSTERIOUS VOICE (V.O.)</h4>
<p>The corrupt infestation that bore you life and meaning. Make it your duty. Make it your obligation. To feel the righteous blow of your steady moral hand of objectivity.</p>
<p></p>
<p>Flashes of DR. THE GAY PERSON, QUEEN SOE DOE MAE, AAAAAAAAAAAAAAAAAAAAY and ROCKE with F-TRON smirking inside.</p>
<p></p>
<h4>MYSTERIOUS VOICE (V.O.)</h4>
<p>Go. Go and search the path. The route of truth.</p>
<p></p>
<p>Start homage level.</p>
<p></p>
<p></p>
<p></p>
<h3>Dan Level 1. Mengerite Clearup.</h3>
<p></p>
<p>Fight blue squares, peasant resistance, red square patrolers (Shoot to disable gun and shoot again to stop it moving. Maybe you can shoot them away too.), Lv1 Meng turrets, Lv2 Meng turrets, a couple of green square confiners, Lv3 Meng mines, Black Lv4 Meng enforcers.</p>
<p></p>
<p>Second to last stage, you fight a Robotron mk1 and a bunch of pink mo-biles.</p>
<p></p>
<p>After Robotron departs, a guy crawls away from his wrecked wheels and phone cools THE COOL GUY.</p>
<p></p>
<h4>DUDE</h4>
<p>The Cool Guy.</p>
<p></p>
<h4>THE COOL GUY</h4>
<p>Sup. Important phone cool?</p>
<p></p>
<h4>DUDE</h4>
<p>Shit. Mother fucking Robotron unit attacked us man.</p>
<p></p>
<h4>THE COOL GUY</h4>
<p>What?! Some cyber punk shit?</p>
<p></p>
<h4>DUDE</h4>
<p>Crazy ass. Gotta spread dat word boi. Trew. He he crazy ass.</p>
<p></p>
<p>DUDE coughs and dies.</p>
<p></p>
<h4>THE COOL GUY</h4>
<p>Mother fucking fucker.</p>
<p></p>
<p>Finish the stage fighting GoliathV1. Unexplained.</p>
<p></p>
<p></p>
<p></p>
<h3>Dan Level 2. Taking The Town.</h3>
<p></p>
<p>Fight blue squares, Peasant resistance, 6 dark left over, Cheers Du Beers moving platforms appear from now on maybe, 2 more Robotron version attacks, more green square confiners like 5 max, Dr. The G Person's defence vendors, pink mo-biles, Divine warrior descendant with Peasant milita, GoliathV2, Black homing things that quickly leach on and slow you down, aaaaaaaaaaaaaaaaaaaay's mother blue homing squares. Then:</p>
<p></p>
<p>THE COOL GUY enters his robot launcher.</p>
<p></p>
<h4>THE COOL GUY</h4>
<p>Fucker. You gonna pay for what you did to mine. Aight aight. Now I knows you. I knows it's you's here Robotron. Dr. The G Person might be all fly up in dat here fold but I ain't takin a fall. Shit. Dumb bitch what? Dumb bitch what?! Bomb You from the ground? Narrr. You gotta haves it now eyauh. Understand what I'm saying?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>THE COOL GUY</h4>
<p>Tuh.</p>
<p></p>
<p>Fight THE COOL GUY near defence vendors, pink mo-biles and red square patroler. When you destroy his robot, THE COOL GUY, being immune to explosions and falls get spun and blown out off the screen.</p>
<p></p>
<h4>THE COOL GUY</h4>
<p>Darnel!</p>
<p>(High pitched.)</p>
<p>Mother fuckerrrrr aw shit!</p>
<p></p>
<p>Maybe you can unlock some the cool guy levels depending on the rocketron engine being compatible with construct, cos you're basically the same guy.</p>
<p></p>
<p>Robotron comes across Loki who transforms into a giant turtle.</p>
<p></p>
<p>Fight him in this form. When he's beaten. He'll shrink back and run away. Level done.</p>
<p></p>
<p></p>
<p></p>
<h3>Dan Level 3. Quest For aaaaaaaaaaaaaaaaaaaay.</h3>
<p></p>
<p>Totally find Jack and Charlie and shoot them for a cameo appearance bonus. More moving cover squares? Fight also; three more Robotron attack waves scattered throughout, more green square confiners 5 would be more appropriate now, a few pink mo-biles, korma buds and billboards – the puddles they shoot cover a lot of ground too and slow you down get you stuck or could continually pile on poisoning damage, agent 420 doing a similar thing – kill him before he escapes to unlock the op420 level.</p>
<p></p>
<p>aaaaaaaaaaaaaaaaaaaay appears halfway with a surprise.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>You again? I should have known. Robotron causing all the trouble. Little cyber punk. What the hell do you have against my dominion?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown. Stop calling it that.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>I should've just killed you when I had the chance instead of leaving you and Rocke to destroy each other. The chances I take eh? Well I'll tell you one thing! I Sure as hell am going to make that mistake again.</p>
<p></p>
<p>aaaaaaaaaaaaaaaaaaaay shoots Robotron with a virus beam or something. Kinda similar to op420 in terms of on screen irritants and inverted controls now and then for the rest of this level.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>(Flying off.)</p>
<p>Ha ha ha ha ha.</p>
<p></p>
<p>Fight, with the virus and maybe the digital virus beast weapon – or wait till you get rid of it to fight it, anti weapon and Robotron gate bots, aaaaaaaaaaaaaaaaaaaay's mother homing blue square brains, Lilith turning into a giant skunk, royal guards.</p>
<p></p>
<p>Space pimp and his hoes and farm machines appear to take Robotron.</p>
<p></p>
<h4>SPACE PIMP</h4>
<p>Hoy hoy hoy. Power! Pow sugar! Ain't no dead fast rigor moris embalming fluid transfer your brittle dead robotron viens my turf bitch. Shiit yeah.</p>
<p></p>
<h4>HO</h4>
<p>Space Pimp you so bad.</p>
<p></p>
<h4>SPACE PIMP</h4>
<p>Shut up bitch. I'm driving here. To let me light the lords way to the most mackenest smackenest on the slight of your cheek. Ooh pity ooh. See Robot guy. You got your robotronic ass owned. I. Own. These girls. The hell is the opposite of that?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>SPACE PIMP</h4>
<p>(Moving in.)</p>
<p>Eh, I suppose so. Shit Mr. Robotron sir. You got your prince pal. You got your prince pal. Time to move in on this ugloi piece of estate.</p>
<p></p>
<p>Beat Space Pimp and the farm machines and his craft will detach and fly away.</p>
<p></p>
<h4>SPACE PIMP</h4>
<p>By the grace good gentlemen. By heavens witness. My command divine and pure of that in faith. The land needs me. All these problems. All against one another. Brothers fighting in such. And no one mother fucking tinman skank lover functionzoida shit bitch gonna take nor think he got hisa rights awwwwn for my great good guidance in the hearts of many many, and i do so say, many peoples can hope here every mother fucker will feel the piercing temple burn of high hell's raging sun! I'll be back fucker! Plunge deeper in. I'll be back fucker! Plunge deeper in fucking soul. Soulllllll!!</p>
<p></p>
<p>Also shoot a secret Rith in the background one level the unlock Evangelist level. Fight GoliathV3 too or maybe another stage later.</p>
<p></p>
<p>AAAAAAAAAAAAAAAAAAAAY is atop some machine which will be a boss.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>Got over my virus then Robotron? Guess you can think your way out of it. That's all you are right? A little rationality got you far. I guess I can empathise. We all have our design faults. I'm glad you got over yours. Hmm? I wonder. What lies beyond the windows of the soul, for you.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>Right. Right, right. Annoying. We shall see shall we? Time to tear you open chiphead motherboarder.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Lame.</p>
<p></p>
<p>Fight AAAAAAAAAAAAAAAAAAAAY boss.</p>
<p></p>
<p>AAAAAAAAAAAAAAAAAAAAY falls to the floor out of his exploding machine, his glasses slide across the room. He stands up grunting. He has six eyes.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>You have six eyes.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>Yes well. I guess it would come out sometime. It's why I did everything really. To get back. All this torment. All this pain. All this secret. Do you know what it's like? Do you know? Can you understand? To live with having six eyes. Six tiny eyes.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>If you had just told us from the beginning it would have been alright. We would have understood.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>Thanks Robotron but it's easier said than done.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>It's ok. Really. Nobody will make fun of you. I promise.</p>
<p></p>
<h4>AAAAAAAAAAAAAAAAAAAAY</h4>
<p>Heh. Well. I guess. Ah. Thanks Robotron.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<p>Level done.</p>
<p></p>
<p></p>
<p></p>
<h3>Dan Level 4. Turning On The Master.</h3>
<p></p>
<p>Fight Blue squares, red square patrolers, the final 4 Robotron alternate attack waves at points, many green square confiners, defence vendors, Korma buds and billboards, Either have GoliathV3 and GoliathV4 at different point here or don't have them here at all, black homing things that leech on and slow you down, aaaaaaaaaaaaaaaaaaaay's homing mother blue squares, Dr. The G Person's red square tank spiders – shoot them once to disable their legs then shoot them again to disable their rapid fire gun and leave them as stationary red squares, also fight Chittulu as a giant hog who runs away in normal form after defeat.</p>
<p></p>
<p>Robtron walks the halls of Dr. The G Person's new base of operations. A voice echoes throughout the hall.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>Ah my soldier returns. Brought me anything good back like I ordered. I have travelled across borders Robotron. I have transferred through dimensions. Come find me. I have all the treasure I brought back.</p>
<p></p>
<p>Fight more till you get to YOUSLUTCUNT?</p>
<p></p>
<p>YOUSLUTCUNT? Is waiting in front of a gate in the middle of the giant arena, spurging goo everywhere.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>The co creator. The Korma monster. Perhaps you need to meet death.</p>
<p></p>
<h4>YOUSLUTCUNT?</h4>
<p>(Gurgles.)</p>
<p></p>
<p>Fight YOUSLUTCUNT? Normal form amongst other enemies and inventions of Dr. The G Person.</p>
<p></p>
<p>Afterwards YOUSLUTCUNT? Collapses into a puddle of korma that begins to spread out. Robotron starts to exit then turns around as the puddle forms into the mutant. Roaring it spews a giant flame beam sending out fire korma buds and blue squares endlessly.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>(Onlooking from the shadows.)</p>
<p>So this is the result of the F-tron weapon. It's power. Nothing I predicted. I doubt F-tron had ever attained this use of power.</p>
<p></p>
<p>DR. THE G PERSON commentates as YOUSLUTCUNT? Roars and flairs around his eyes burning red.</p>
<p></p>
<h4>DR. THE G PERSON (V.O.)</h4>
<p>The Spirit is F-tron. F-tron trying to break through. Trying to take the body over. The same weapon is part of Robotron now. I wonder if he can, if there's any recognition?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Somefunknown.</p>
<p></p>
<p>Fight and kill the YOUSLUTCUNT? Mutant and it's crazy F-tron weapon. Afterwards the mutant will explode and die.</p>
<p></p>
<p>Soon after you get the giant Robotron upgrade which makes you invincible and storm the factory killing everything you touch.</p>
<p></p>
<p>Eventually you get to Dr. The G Person standing atop a dome.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>Ah Robotron. I suspect you've figured out what's going on. Why you've encountered duplicates of yourself?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>Ah yes well. You see Robotron. When I found you in my reactor. Slain by the blue hands of Rocke. I. I saw something. It's true that Queen Soe Doe Mae did indeed create you. But I have made you more than you could ever have been under his directive. You don't remember any of this do you Robotron?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Uuuuuuh.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>It will become very clear very soon. Your synthetic brain is the only one capable of perceiving the true nature of what will happen here. The world we, as men, have left in ruin. Bad communication Robotron. Leads to the fall of humanity. That's what the past was all about. So what comes next? Reform? Rebirth. In the form of you. You and your brothers me and the late YOUSLUTCUNT? Developed in mass production. Not many got passed the prototype stage and as such not many were completed. And, thanks to you, not many got passed the induction stage.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>What? Right?</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>What right Robotron? Is this it then? An aversion to your duplicity. That's the reason you're fighting me Robotron? Turning against your work. What reason are you, ha! Rebelling?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>Exactly. That's why I left you off Robotron. You were a defective model. An inferior replica. An obsolete design. Oh that's right Robotron. There is one remaining copy. A copy of your precious program and it's inside you. Incomplete.</p>
<p></p>
<p>Robotron raises his arm to shoot Dr. The G Person but the dome he's standing on lights up and turns out to be the head of another giant Robotron.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>See this is the original Robotron. Loyal, born tame and objective. The way forward. Argh but just as he did to my company from the inside, aaaaaaaaaaaaaaaaaaaay gave birth to corruption triggering an upstart imperfection that can never be stopped. Only by the hand of god. The God from the machine. Machine! Earn it!</p>
<p></p>
<p>Giant Robotron fight. When he's on low health, your giant upgrade wears off and you have to run away and shoot him up before he catches up to you.</p>
<p></p>
<p>The original explodes and a green flash shimmers towards you. The screen flashes with 'You now have Robotrons memories'. Dr. The G Person, teleported elsewhere opens a portal and sends Robotron spinning into the blackness. While in the portal General Kafilta quickly flies past stating his name and slicing a Rith with a sword.</p>
<p></p>
<h4>DR. THE G PERSON(V.O.)</h4>
<p>Now you know the truth Robotron, you can know this. You cannot defeat me Robotron. But I cannot defeat you. Not because you are a dominant being, but because I cannot bring myself to destroy such a prodigal creation. Go forth Robotron. You have earned the right to fight and rule in other worlds. And hopefully, hopefully. You'll understand how the worlds and different dimensions, parallel universes, depths, work together and function in such a harmonious procedure, that when you do come back. Come and find me. Come and empathise, understand and grow with my mission for the rest.</p>
<p></p>
<p>As Robotron stops spinning, he slowly floats across space. And in the background the ISS Terran ent appears.</p>
<p></p>
<p>Level done unlock a shitload of other diverse levels.</p>
<p></p>
<p></p>
<p></p>
<h3>Dan Level 5. Queen Soe Doe Mae's Top Down Castle Exploration.</h3>
<p></p>
<p>Queen Soe Doe Mae, atop his worship alter, is looking out from his castle window and conversing with the voice of the angelic.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>Your holiness. The townspeople are amassing outside. They appear disgruntled with my position here. I beg you for aid.</p>
<p></p>
<h4>THE ANGELIC</h4>
<p>Eunuch. The blood of a parasite flows within your shell. Did you not think I was unaware of your intent. Your intent to use and harness the destructive forces of the spirit. Divine manipulator. You are nothing more than a pawn placed to stop the oncoming attack of an unwanted irritant. You will not make it across this side of the board. You will not become a true queen.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>But. My lord. I have many soft cute bunnies here to sacrifice for. I mean, I am yours. Eternally.</p>
<p></p>
<h4>THE ANGELIC</h4>
<p>Precisely Soe Doe Mae. And I no longer care for you. The dark master F-tron has washed his hands of the poison murk of men. This world will be cleansed and born anew, void of such delusional fools. And they will remove themselves from this world.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>Please arch angel. What can I do. I will sacrifice myself to you. Enslave myself to.</p>
<p></p>
<h4>THE ANGELIC</h4>
<p>You. None of your kind will understand the metaphysical realms that await those of pure power and progression. Fall and Fail here.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>I guess I wouldn't give my soul away really. Not yet.</p>
<p></p>
<p>THE ANGELIC shines away.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>(Flipping through a book.)</p>
<p>I guess I still have these bunnies to use. It seems I need a new figure to worship.</p>
<p></p>
<p>Fight and explore, finding things out about shit in this exploding castle. Fight Eunuchs, royal guards, green square confiners, invading peasant militia and invading slow Blueskin walking turrets. Uncover the three horsietrons of treasure hidden about from T2F2. Eventually make it to Queen Soe Doe Mae's lair.</p>
<p></p>
<p>Robotron bursts in. Queen Soe Doe Mae spins around.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>Ah my old creation. How have you been? Thought you were dead.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>Er. Alright. What you want? To catch up? Or hey you could protect me. Yeah. Yeah that's good right?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>(Raising his gun.)</p>
<p>To all. Unknown.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>Ah I see. I've seen it all from here. You got yourself a new master haven't you?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>QUEEN SOE DOE MAE</h4>
<p>Whatever. I have a new master too. And he resurrected this very special gift just for me. Ha ha ah ah aha ha haa!</p>
<p></p>
<p>QUEEN SOE DOE MAE steps aside to present Chriss$. He then jumps out the window laughing.</p>
<p></p>
<p>Fight Chriss$ in normal form. Beat him. You then both turn giant and crush the castle. Fight him in the battle of the epic. Level Done.</p>
<p></p>
<p></p>
<p></p>
<h3>Dan Level 6. Between Rocke and A Hard Place.</h3>
<p></p>
<p>Fight the final few green square confiners, angels, Blueskin walking turrets, f-tron demons, GoliathV4 maybe and definitely GoliathV5, anti weapon and Robotron gates bots, the land guardian sub boss.</p>
<p></p>
<p>Eventually Robotron finds himself in front of a mysterious figure enveloped in shadow.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Naturally I found myself being led here.</p>
<p></p>
<h4>MYSTERIOUS VOICE</h4>
<p>Long journey but it ends here tron.</p>
<p>(Emerging into the light.)</p>
<p>No I think it's time I showed you my real face. The real face of divinity and destiny. Reputation and responsibility handed down.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>And you are?</p>
<p></p>
<h4>MYSTERIOUS VOICE THE DIVINE DESCENDANT</h4>
<p>Asking questions Robotron. Finding the solutions to all those unknown answers. I am the anonymous divine descendant. I'm the voice you heard during your booting. You must remember. I awoke you after Dr. The G Person left you in his soon to be invaded factory. I sent you on your mission.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>You awoke me?</p>
<p></p>
<h4>DIVINE DESCENDANT</h4>
<p>As I announced my heritage to the noble bloodline, many others, too, stepped forward. Of course not all where what they claimed. Some were delusional. Some were desperate for change or purpose in their small lives. They were all use to me nevertheless. But it was you Robotron, who were suited for this mission. A world in ruin. Corrupted, plagued and festering. Too much life and all filled of vice. It needed cleansing tron. The criminals who had built shame into our societal infrastructure, the souls who dwelled within and were grossly beyond redemption. The demons. They all wanted each others blood and they all had to go. Reform. A new age. A new start. I noticed you in the shadows and there was something venerable about you. You. Then it occurred to me. You. You were no mortal being. Deep within you, ever so slowly, sentience had opened its eyes. Only you could finish the final obstacle F-tron and leave the synthetic yet moral warrior without him possessing your soul and vessel. It seems however that part of him lives within you already. The question is now, will you kill me too?</p>
<p></p>
<p>Robotron walks away.</p>
<p></p>
<h4>DIVINE DESCENDANT</h4>
<p>Where are you wondering to?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>DIVINE DESCENDANT</h4>
<p>Are you going to kill me? If you kill me you will kill the last. Finish the final remains of the noble divine bloodline. You will end it here. I will fall a martyred testament to the old ways. The old approaches to the problems, still unsolved which I swear, will return and still claim you.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>I won't be destroying the old ways. Not the old methods or approaches. Just the myths surrounding them and how to deal with them. The ones just as corrupted and contrived. You are an obsolete design. We will not forget the old ways and methods, the same problems still presented to us. We will harness a greater practical approach to them whilst maintaining the journey of how we got to our current understanding. No dead dogma. Standing on the shoulders of giants whilst glimpsing at their shoes.</p>
<p></p>
<p>ROBOTRON turns around and shoots the ceiling on top of the DIVINE DESCENDANT, crushing him.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>That takes care of the burial.</p>
<p></p>
<p>ROBOTRON makes his way to ROCKE sitting on a throne with blueskins and monks beside him. They notice ROBOTRON and load their guns. ROCKE halts the order to fire.</p>
<p></p>
<h4>ROCKE</h4>
<p>Good to see you made it Robotron.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>ROCKE</h4>
<p>Another one for the spirit within to kill. Men step down. This is an old fight.</p>
<p></p>
<p>ROCKE steps over to ROBOTRON dragging along his rocket launcher.</p>
<p></p>
<h4>ROCKE</h4>
<p>You know it's a lie what the scrolls say. He didn't take me over straight away. I struggle with him at times but he's always in control. Sometimes, some times I find myself agreeing with him. Pleased for him. Anticipating his outlooks. I don't. I don't know what I think anymore. Free me Robotron.</p>
<p></p>
<p>ROCKE aims at ROBOTRON.</p>
<p></p>
<h4>ROCKE</h4>
<p>Hey Robotron. Another joke? Why did the robot head cross the road?</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>ROCKE</h4>
<p>Well. We'll see about that.</p>
<p></p>
<p>Fight Rocke somehow. Win.</p>
<p></p>
<p>ROCKE (F-TRON POSSESSED.)</p>
<p>Mannequin. Die. Die as the hollow toy you are. And give me the rest of me!</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Take. It. All.</p>
<p></p>
<p>ROBOTRON'S F-TRON weapon activates and a rush wave of green laser, blue square and flame hits ROCKE and some blueskins and monks. Others dive out the way. The debris falls and visibility is restored.</p>
<p></p>
<h4>ROCKE</h4>
<p>(Struggling to stand up.)</p>
<p>Why did the robot head cross the road? Cos Rocke T Ron blew it over there.</p>
<p></p>
<p>ALBINO F-TRON roars as he tears out of ROCKE who is blown backwards and falls down a gorge in the floor.</p>
<p></p>
<h4>ALBINO F-TRON</h4>
<p>I! Am! Destroyer!</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Mmmm.</p>
<p></p>
<h4>ALBINO F-TRON</h4>
<p>The universe will feel my rage and hunger. Demons, Angels. Those damn brothers. They will all know my name they will know who I am. I will be...</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Unknown.</p>
<p></p>
<h4>ALBINO F-TRON</h4>
<p>Garrrrgh!</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Fuck you whitey ghostface killah.</p>
<p></p>
<p>ALBINO F-TRON roars and sprays an attack wave everywhere killing the other monks and blueskins.</p>
<p></p>
<p>Destroy ALBINO F-TRON in stages.</p>
<p></p>
<p>An open portal F-TRON shot remains open as he roars and explodes in a shower of blood. His body falling apart charges for Robotron but becomes nothing when he gets close. Only a bloodied clump of goo is left. Robotron shoots a Robotron green box and locks the chromoston inside and shoots it towards the portal.</p>
<p></p>
<p>Suddenly Dr. The G Person flies across the room, intercepting the chromostron. Very soon after Rocke flies up from bellow with a rocket jump and lands on the floor. His legs don't work, he is too weak.</p>
<p></p>
<p>The Dr. and Rocke instantly point their guns at each other. A red square and a rocket launcher.</p>
<p></p>
<p>Robotron aims each of his guns at both characters who also each aim back at him with their other arms.</p>
<p></p>
<h4>ROCKE</h4>
<p>Didn't get to do this last time. Finish you and stop you from doing anymore.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>Rocke. Like I said to Robotron. I've seen things now. Though things over. I know how they are. It's all about rebirth. I'm reformed Rocke. So are you. Congratulations.</p>
<p></p>
<h4>ROCKE</h4>
<p>Put down that chromostron. You will not make that hellish weapon.</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>I will use it for good Rocke. The right way. It will help the world and compensate for everything I've done. We've done.</p>
<p></p>
<h4>ROCKE</h4>
<p>Fuck you. Trust any of us Robotron?</p>
<p></p>
<h4>DR. THE G PERSON</h4>
<p>So Robotron. Who are you going to side with here?</p>
<p></p>
<h4>ROCKE</h4>
<p>Yeah what are you going to do now?</p>
<p></p>
<p>Zoom in on Robotron. Anticipating his reaction.</p>
<p></p>
<h4>ROBOTRON</h4>
<p>Un.</p>
<p>(Cut off by the credits.)</p>
<p></p>
<p></p>
<p>Maybe after there could be a hypothetical choose situation where if you shoot Rocke you hear Dr. The g Person's vision of the future. If you shoot Dr. The G Person you get rocke on your shoulders hat.</p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<p></p>
<h4>Robotron</h4>
<p>knock knock</p>
<p></p>
<p>who's there</p>
<p></p>
<h4>Robotron</h4>
<p>Unknown</p>
<p></p>
<p>Unknown who?</p>
<p></p>
<h4>Robotron</h4>
<p>I dunno. Unknown unknown</p>
<p></p>
<p>or</p>
<p></p>
<p>Unknown who it was who put that bomb on the place you're stanind right now</p>
<p>explodes</p>
<p>Or no wait, I did it!</p>
<p></p>

</div>



		</div>
	  </Box>



}


export default HighScores